module.exports = __webpack_public_path__ + "static/mysa-mattress-3-dd630c0d7854ce2d1849cbdec99db52a.webp";